<template>
  <div class="modal fade" id="edit_holiday_modal" tabindex="-1" aria-labelledby="editHolidayModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="edit_holiday_modal_label">{{ $t("accounting.label.edit_holiday") }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="updateHoliday" method="post">
              <kt-form-section>
                <!-- Second Row: Account Number Field -->
                <kt-form-row>
                  <kt-col xs="12">
                    <kt-form-group>
                      <kt-form-label for="holiday_date">
                        {{ $t('accounting.label.holiday_date') }}
                      </kt-form-label>
                      <button id="reset_holiday_date"
                              @click="clearDate"
                              type="button"
                              class="btn btn-label-danger trash-btn"
                      >
                        <i class="la la-trash-o"></i>
                      </button>
                      <datePicker
                          format="jYYYY-jMM-jDD"
                          display-format="jDD jMMMM jYYYY"
                          input-class="form-control"
                          id="holiday_date"
                          name="holiday_date"
                          v-model="holiday_date"
                          type="date" />

                      <div v-if="errors.holiday_date" class="text-danger">
                        {{ errors.holiday_date.join(', ') }}
                      </div>
                    </kt-form-group>
                  </kt-col>
                </kt-form-row>
              </kt-form-section>
  
              <kt-row>
                <kt-col xs="12" sm="6" md="6">
                  <button
                      class="btn btn-success btn-wide float-left"
                      size="md"
                      type="submit"
                      id="create_holiday_btn"
                  >
                    {{ $t("accounting.create_holiday") }}
                  </button>
                </kt-col>
              </kt-row>
            </form>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { accountingService } from "@/common/api.service";
import { EventBus } from "../index";
import $ from 'jquery';
import { starShopAccountingService } from "../../../common/api.service";

export default {
  name: "HolidayEditModal",

  data() {
    return {
      holiday: null,
      holiday_date: "",
      errors: {},
    };
  },
  mounted() {      
    EventBus.$on('edit-holiday', (holidayData) => {
      this.holiday = holidayData;
      this.holiday_date = holidayData.holiday_date;
      this.errors = {};
      this.showModal();
    });
  },
  methods: {
    updateHoliday() {
    const service = this.$route.path.includes('pf') ? accountingService : starShopAccountingService;
    service.updateHoliday(this.holiday.id, { holiday_date: this.holiday_date })
      .then(response => {
        this.$emit('holiday-updated', response.data);
        $('#edit_holiday_modal').modal('hide');
      })
      .catch(({ response }) => {
        this.errors = {};
        if (response && response.data) {
          const { errors: errorList } = response.data;
          this.errors = { ...errorList };
        }
      });
  },
    showModal() {      
      $('#edit_holiday_modal').modal('show');
    },
    clearDate() {
      if (this.holiday_date) {
        this.holiday_date = null;
      }
    },

  },
  watch: {
    holiday(newValue) {
      this.holidayDate = newValue.holiday_date;
    }
  }
};
</script>
  